export default "__VITE_ASSET__Bje66Fyq__"